webpackJsonp([0,2],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(9)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(3),
  /* template */
  __webpack_require__(19),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MenuBar__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MenuBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_MenuBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Projects__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Projects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Projects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SobreMi__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SobreMi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_SobreMi__);







/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',
  components: {
    menubar: __WEBPACK_IMPORTED_MODULE_0__components_MenuBar___default.a,
    footerbar: __WEBPACK_IMPORTED_MODULE_1__components_Footer___default.a,
    projects: __WEBPACK_IMPORTED_MODULE_2__components_Projects___default.a,
    sobremi: __WEBPACK_IMPORTED_MODULE_3__components_SobreMi___default.a
  }
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'footerbar',
  data: function data() {
    return {};
  }
};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
};

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scrollreveal__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scrollreveal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_scrollreveal__);




/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      projects: [{
        name: 'Operativo',
        description: 'Manejo de certificados de salud para una empresa',

        img: 'operativo.png'
      }]
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_scrollreveal___default()({ duration: 500, delay: 200 }).reveal('.column');
  },

  methods: {
    loadImage: function loadImage(url) {
      return __webpack_require__(23)("./" + url);
    }
  }
};

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      datos: [{
        icon: 'fa fa-graduation-cap',
        msg: 'Estudiante de ingeniería en telecomunicaciones y entusiasmado por aprender las nuevas tecnologías web.'
      }, {
        icon: 'fa fa-cog',
        msg: 'Capacidad de aprender rápido y trabajar     eficazmente en equipo. Dipuesto a escuchar a los demás y recibir críticas.'
      }, {
        icon: 'fa fa-cloud icon-block',
        msg: 'Capaz de manejar tecnologías web tanto del lado del servidor como del cliente.'
      }]
    };
  }
};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/operativo.29bab8f.png";

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(8)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(17),
  /* scopeId */
  "data-v-082d5cb7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(16),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(20),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(18),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "hero-head"
  }, [_c('header', {
    staticClass: "nav has-shadow"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('a', {
    staticClass: "nav-item is-brand",
    attrs: {
      "href": "index.html"
    }
  }, [_c('p', {
    staticClass: "title is-4-mobile"
  }, [_vm._v("Ignacio Del Nardo")])])]), _c('div', {
    staticClass: "nav-center"
  }, [_c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "https://github.com/mrignacio1231"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-github"
  })])]), _c('a', {
    staticClass: "nav-item"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "https://www.linkedin.com/in/ignaciodelnardo/"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })])])]), _c('span', {
    staticClass: "nav-toggle"
  }, [_c('span'), _c('span'), _c('span')]), _c('div', {
    staticClass: "nav-right nav-menu"
  }, [_c('a', {
    staticClass: "nav-item is-active",
    attrs: {
      "data-scroll": "",
      "href": "#inicio"
    }
  }, [_vm._v("Home")]), _c('a', {
    staticClass: "nav-item",
    attrs: {
      "data-scroll": "",
      "href": "#projects"
    }
  }, [_vm._v("Proyectos")])])])])])])
}]}

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "has-text-centered white"
  }, [_c('p', [_vm._v("Diseñado por"), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Ignacio")])]), _c('p', [_c('a', {
    staticClass: "icon",
    attrs: {
      "href": "https://github.com/mrignacio1231"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  })])])])])])])
}]}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section main"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.datos), function(dato) {
    return _c('div', {
      staticClass: "column is-4"
    }, [_c('div', {
      staticClass: "panel section"
    }, [_c('div', {
      staticClass: "panel"
    }), _c('p', {
      staticClass: "has-text-centered"
    }, [_c('i', {
      class: [dato.icon, 'icon-block']
    })]), _c('br'), _c('p', [_vm._v(_vm._s(dato.msg))]), _c('br')])])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('section', {
    staticClass: "hero is-primary is-medium header-image",
    attrs: {
      "id": "inicio"
    }
  }, [_c('menubar'), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('sobremi'), _vm._v(" "), _c('projects'), _vm._v(" "), _c('footerbar')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-cta"
  }, [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('p', {
    staticClass: "title is-2"
  }, [_vm._v("Sobre mí")])])])])
}]}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "section main"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _c('div', {
    staticClass: "columns is-desktop"
  }, _vm._l((_vm.projects), function(project) {
    return _c('div', {
      staticClass: "column is-4"
    }, [_c('div', {
      staticClass: "media section"
    }, [_c('figure', {
      staticClass: "media-left"
    }, [_c('p', {
      staticClass: "image is-128x128"
    }, [_c('img', {
      attrs: {
        "src": _vm.loadImage(project.img) || 'http://bulma.io/images/placeholders/128x128.png'
      }
    })])]), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('p', {
      staticClass: "title",
      domProps: {
        "textContent": _vm._s(project.name)
      }
    }), _c('p', {
      domProps: {
        "textContent": _vm._s(project.description)
      }
    })])])])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading",
    attrs: {
      "id": "projects"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Proyectos realizados")])])
}]}

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./operativo.png": 11
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);



new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
  mounted: function mounted() {
    smoothScroll.init();

    var burger = document.querySelector('.nav-toggle');
    var menu = document.querySelector('.nav-menu');
    burger.addEventListener('click', function () {
      burger.classList.toggle('is-active');
      menu.classList.toggle('is-active');
    });
  }
});

/***/ })
],[24]);


// WEBPACK FOOTER //
// static/js/app.1758f1f834befa0df5cd.js